import Image from "./image";
import PreviewInner from "./previewInner";
import Preview from "./preview";
import "@douyinfe/semi-foundation/image/image.scss";

export default Image;
export {
    PreviewInner,
    Preview,
}; 

export type {
    ImageProps,
    PreviewImageProps,
    PreviewProps,
    MenuProps
} from "./interface";